import React from "react";
import styled from "styled-components";
// import common components
import Typography, { TYPE_ELEMENTS } from "./Typography";

const CTA = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: fit-content;
  padding: 4px 8px;
  box-sizing: border-box;
  width: ${(props) => (props.whiteBg === "true" ? "160px" : "180px")};
  height: ${(props) => (props.whiteBg === "true" ? "48px" : "62px")};
  background-color: ${(props) => (props.whiteBg === "true" ? "#ff4f00" : "#060812")};
  color: ${(props) => (props.whiteBg === "true" ? "#fff" : "#fff")};
  border: 2px solid white;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0%;
    background: linear-gradient(to top, #ff4f00 0%, transparent 50%);
  }

  &:hover {
    background: ${(props) => (props.whiteBg === "true" ? "#000" : "#fff")};
    color: ${(props) => (props.whiteBg === "true" ? "#ff4f00" : "#000")};
    border-color: ${(props) => (props.whiteBg === "true" ? "#ff4f00" : "#fff")};
    font-weight: 400;
    transition: all 0.3s ease-in-out;
    // box-sizing: border-box;
  }

  @media (max-width: 768px) {
    ${({ whiteBg }) => whiteBg && `
      width: 180px;
      height: 50px;
    `}
  }

  @media (max-width: 480px), (max-height: 480px) {
    ${({ whiteBg }) => whiteBg && `
      width: 140px;
      height: 40px;
    `}
  }
`;

export default function CTAButton({ text, onClick = () => {}, whiteBg = false }) {
  return (
    <CTA onClick={onClick} whiteBg={`${whiteBg}`}>
      <Typography typeElement={whiteBg ? TYPE_ELEMENTS.BODY_3 : TYPE_ELEMENTS.BUTTON} customWeight={"700"}>{text}</Typography>
    </CTA>
  );
}

const CTA1 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 224px;
  height: 48px;
  background: #ff4f00;
  color: white;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0%;
    background: linear-gradient(to top, #232c60 0%, transparent 40%);
  }

  &:hover {
    background: transparent;
    border: 2px solid #fff;
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;
  }

  &:hover::after {
    height: 100%;
    transition: height 0.3s ease-in-out;
  }

  @media (max-width: 1024px) {
    width: 180px;
    height: 40px;
  }

  @media (max-width: 768px) {
    width: 160px;
    height: 36px;
  }

  @media (max-width: 480px) {
    width: 140px;
    height: 36px;
  }
`;

export function CTAVariant1({ text, onClick = () => {} }) {
  return (
    <CTA1 onClick={onClick}>
      <Typography typeElement={TYPE_ELEMENTS.BUTTON}>{text}</Typography>
    </CTA1>
  );
}

const FormCTAContainer = styled.div`
  position: relative;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff;
  border: 2px solid #fff;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background-color: #fff;
    color: #000;
  }
`;

export function FormCTA({ text, onClick = () => {} }) {
  return (
    <FormCTAContainer onClick={onClick}>
      <Typography typeElement={TYPE_ELEMENTS.BUTTON}>{text}</Typography>
    </FormCTAContainer>
  );
}
